<template>
  <div v-loading.fullscreen.lock="fullscreenLoading"/>
</template>

<script>
import http from '@/services/http.service'
export default {
  name: 'AuthActivate',
  data () {
    return {
      fullscreenLoading: false
    }
  },
  mounted () {
    this.fullscreenLoading = true
    http.get('verify-account/' + this.$route.params.token).then((response) => {
      this.$notify.success({
        title: 'Correcto',
        message: 'Cuenta verificada, por favor ingresa nuevamente'
      })
    }).catch((e) => {
      this.$router.push({name: 'Home'})
      this.$notify.error(e)({
        title: 'Error',
        message: 'No se pudo verificar tu cuenta'
      })
    }).finally(() => {
      this.fullscreenLoading = false
    })
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/auth/auth-confirm-account.vue